module.exports = __webpack_public_path__ + "static/img/bg_coupon_three.b042eef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg_coupon_three.png
// module id = cVrw
// module chunks = 0